import type {FC} from 'react';

import type {ButtonProps} from '@/components/button';
import {CallToAction} from '@/components/call-to-action/CallToAction';
import {CallToActionGroup} from '@/components/call-to-action-group/CallToActionGroup';
import {cn} from '@/utils/tailwind';

import {linkFragmentToHref} from '../../link/query';

import type {CallToActionLineFragment} from './query';

interface Props {
	value: CallToActionLineFragment;
	buttonProps?: ButtonProps;
	groupProps?: {
		className?: string;
	};
	className?: string;
}

export const CallToActionLine: FC<Props> = ({
	value,
	className,
	buttonProps,
	groupProps,
}) => {
	return (
		<CallToActionGroup className={cn(groupProps?.className, className)}>
			{value.callToActions?.map((cta) => (
				<CallToAction
					key={cta._key}
					text={cta.text ?? ''}
					targetBlank={cta.targetBlank}
					href={linkFragmentToHref({
						type: cta.type,
						href: cta.href,
						reference: cta.reference,
						targetBlank: cta.targetBlank,
					})}
					buttonProps={{
						size: buttonProps?.size ?? 'medium',
						intent: cta.color ?? buttonProps?.intent,
						...buttonProps,
					}}
				/>
			))}
		</CallToActionGroup>
	);
};
